/** @jsx jsx */

import { useState } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import cross from 'assets/Cross.svg';
import plusHover from 'assets/Plus.svg';
import plus from 'assets/Plus_purple.svg';

const { lPink } = colors;

const width = 17;
const height = 17;
const optionBackground = '#28292B';

const fontSize = 10;

const RemoveBtn = ({ onClick, index, enabled }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: ${width}px;
        height: ${height}px;
        margin: 2px;
        ${index === 0 && `margin-left: 0;`}
        border-radius: 50%;
        border: 1px solid ${hover ? lPink : optionBackground};
        background: ${hover ? lPink : optionBackground};
        color: #fff;
        transition: all 0.1s;
        cursor: pointer;
        font-size: ${fontSize}px;
        ${!enabled && 'pointer-events: none;'}
      `}
      onMouseOver={e => {
        setHover(true);
      }}
      onMouseOut={e => {
        setHover(false);
      }}
      onClick={onClick}
    >
      {hover ? (
        <img src={cross} style={{ width: 10, pointerEvents: 'none' }} />
      ) : (
          index + 1
        )}
    </div>
  );
};

const AddRemoveBtns = ({
  block,
  options = null,
  onClickAdd,
  onClickRemove,
  enabled = false,
}) => {
  return (
    <div
      css={css`
        display: flex;
      `}
    >
      {((options || block.children) as any).map((child, index) => {
        return (
          <RemoveBtn
            key={child.id}
            onClick={() => onClickRemove(index)}
            index={index}
            enabled={enabled || block.children.length > 1}
          />
        );
      })}

      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${width}px;
          height: ${height}px;
          margin: 2px 0 2px 2px;
          border-radius: 50%;
          border: 1px solid #c0d4fe;
          background: url('${plus}') no-repeat;
          background-size: 7px 7px;
          background-position: center;
          transition: all 0.1s;
          cursor: pointer;
          &:hover {
            background: #c0d4fe url('${plusHover}') no-repeat;
            background-size: 7px 7px;
            background-position: center;
          }
        `}
        onClick={() => onClickAdd()}
      />
    </div>
  );
};

export default props => (
  <div
    css={css`
      margin: 5px 0 0 0;
    `}
  >
    <AddRemoveBtns {...props} />
  </div>
);
